<div class="row">
  <div class="col-12">
    <table class="table">
      <caption class="sr-only">Tabella lista dipartimenti</caption>
      <thead>
        <tr>
          <th class="col-xs-3">Nome dipartimento</th>
          <th class="col-xs-3">Società</th>
          <th class="col-xs-3">N° membri</th>
          <th class="col-xs-3"></th>
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let department of dipartments.items">
          <td class="col-xs-3 cell">{{department.name}}</td>
          <td class="col-xs-3 cell">{{department.company.name}}</td>
          <td class="col-xs-3 cell">
            <p class="ml-20">{{department.members.length}}</p>
          </td>
          <td class="">

            <div class="data_opzioni classificazione">
              <ul>
                <li class="opzioni" appDropdownFocus>
                  <a class="dropdown-toggle" data-toggle="dropdown" href="#" role="button" aria-haspopup="true"
                    aria-expanded="false">Opzioni<span class="glyphicon glyphicon-option-vertical"></span></a>
                  <div class="dropdown-menu dropdown-table">
                    <ul>
                      <li><span class="glyphicon ml-0 glyphicon-pencil span-icon"></span><a href="javascript:void(0)"
                          (click)="onEdit(department)">Modifica</a></li>
                      <li *ngIf="department.members.length === 0"><span class="glyphicon ml-0 glyphicon-trash span-icon"></span><a href="javascript:void(0)"
                          (click)="onDelete(department)">Elimina</a></li>
                      <li><span class="glyphicon ml-0 glyphicon glyphicon-cog span-icon"></span><a href="javascript:void(0)"
                        [routerLink]="['dettaglio', department.joinId ]">Gestione dipartimento</a></li>
                    </ul>
                  </div>
                </li>
              </ul>
            </div>

          </td>
        </tr>
      </tbody>
    </table>
  </div>
</div>

<div class="card-pagination">
  <app-pagination
   [totalItems]="dipartments.totalItems"
   [hasAutoRefresh]="true"
   [resetCurrentPage]="resetCurrentPage"
   (refreshEvent)="refreshEvent.emit($event)">
   </app-pagination>
</div>
